import { url, language } from "../helpers";

export default function useRoutes() {
  function productIndex() {
    if (language() === "hu") {
      return url("/termek");
    } else if (language() === "cs") {
      return url("/produkt");
    }

    return url("/produkt");
  }

  function cartIndex(step = 1) {
    if (language() === "hu") {
      return url(`/kosar/${step}`);
    } else if (language() === "cs") {
      return url(`/kosik/${step}`);
    }

    return url(`/kosik/${step}`);
  }

  function cartStore(step = 1) {
    if (language() === "hu") {
      return url(`/megrendeles`);
    } else if (language() === "cs") {
      return url(`/objednavka`);
    }

    return url(`/objednavka`);
  }

  function productDetail(slug) {
    if (language() === "hu") {
      return url(`/termek/${slug}`);
    } else if (language() === "cs") {
      return url(`/produkt/${slug}`);
    }

    return url(`/produkt/${slug}`);
  }

  function vop() {
    if (language() === "hu") {
      return url(`/altalanos-szerzodesi-feltetelei`);
    } else if (language() === "cs") {
      return url(`/vseobecni-obchodni-podminky`);
    }

    return url("/vseobecne-obchodne-podmienky");
  }

  function editProduct(product, index) {
    const url = `${product.slug}?edit=${index}`;

    return productDetail(url);
  }

  return {
    // cart
    cartIndex,
    cartStore,
    // product
    productDetail,
    productIndex,
    editProduct,
    // other
    vop,
  };
}
